import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, mergeProps as _mergeProps, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useEmployeeStore } from "@/stores/employees";
import { Employee } from "@/types";
import InnForm from "@/components/ds/form/Form.vue";
import NavigateBack from "@/components/ds/navigate-back/NavigateBack.vue";
import { useDebounceFn } from "@vueuse/core";
import employeeFormConfig from "./employee-form-config";
import IconButton from "@/components/ds/icon-button/IconButton.vue";
import api from "@/api";
import InnButton from "@/components/ds/button/Button.vue";
import { useUiStore } from "@/stores/ui";
import ClientDetails from "@/components/pages/client/ClientDetails.vue";
import ClientSecondary from "@/components/pages/client/ClientSecondary.vue";
import Panel from "@/components/general/Panel.vue";
import ClientTools from "@/components/pages/client/ClientTools.vue";
import ItemPage from "@/components/general/ItemPage.vue";
import InnSection from "@/components/general/Section.vue";
import EmployeeMail from "@/components/pages/employee/EmployeeMail.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const employeesStore = useEmployeeStore();
const uiStore = useUiStore();

const employee = ref<Employee | null>(null);
const watchActive = ref(false);

const atBack = () => {
    router.push({ name: "Employees" });
};

const deleteEmployee = () => {
    if (employee.value) {
        api.delete(employee.value, "users").then(() => {
            if (employee.value) {
                employeesStore.delete(employee.value);
            }
            router.push({ name: "Employees" });
            uiStore.message("Werknemer verwijderd...");
        });
    }
};

const debouncedFn = useDebounceFn(() => {
    if (employee.value) {
        api.update(employee.value, "users").then(() => {
            uiStore.message("Wijzigingen opgeslagen...");
        });
    }
}, 1000);

watch(
    () => employee.value,
    () => {
        if (watchActive.value) {
            debouncedFn();
        }
    },
    { deep: true }
);

onMounted(() => {
    const id = Number(route.params.id);
    const e = employeesStore.list.find(
        (employee: Employee) => employee.id == id
    );
    if (e) {
        employee.value = e;
        setTimeout(() => {
            watchActive.value = true;
        });
    } else {
        router.push({ name: "Employees" });
    }
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (employee.value)
    ? (_openBlock(), _createBlock(ItemPage, { key: 0 }, {
        header: _withCtx(() => [
          _createVNode(NavigateBack, { onClick: atBack }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode(" Terug naar werknemers ")
            ])),
            _: 1
          })
        ]),
        cols: _withCtx(() => [
          _createVNode(Panel, { title: "Details" }, {
            default: _withCtx(() => [
              _createVNode(InnForm, {
                config: _unref(employeeFormConfig),
                value: employee.value
              }, null, 8, ["config", "value"])
            ]),
            _: 1
          }),
          _createVNode(Panel, { title: "Mail" }, {
            default: _withCtx(() => [
              _createVNode(EmployeeMail, { employee: employee.value }, null, 8, ["employee"])
            ]),
            _: 1
          }),
          _createVNode(Panel, { title: "Tools" }, {
            default: _withCtx(() => [
              _createVNode(InnSection, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_dialog, { "max-width": "500" }, {
                    activator: _withCtx(({ props: activatorProps }) => [
                      _createVNode(IconButton, _mergeProps(activatorProps, {
                        "icon-id": "trash",
                        variant: "danger"
                      }), {
                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                          _createTextVNode(" Verwijder werknemer ")
                        ])),
                        _: 2
                      }, 1040)
                    ]),
                    default: _withCtx(({ isActive }) => [
                      _createVNode(_component_v_card, { style: {"padding":"12px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              _createTextVNode(" Wil je " + _toDisplayString(employee.value.name) + " verwijderen? ", 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_card_actions, null, {
                            default: _withCtx(() => [
                              _createVNode(InnButton, {
                                onClick: 
                                            () => {
                                                isActive.value = false;
                                                deleteEmployee();
                                            }
                                        
                              }, {
                                default: _withCtx(() => _cache[2] || (_cache[2] = [
                                  _createTextVNode(" Verwijderen ")
                                ])),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})